"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function FamilyHistory() {
  const {
    ref: contentRef,
    isVisible: contentVisible
  } = useRevealOnScroll({
    threshold: 0.2,
    once: true
  });
  return <section id="historia-familiar" className="section relative min-h-screen w-full overflow-hidden bg-background">
      {}
      <div className="hero-img absolute inset-0 bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1552070/img/heritage_family_olive_grove.png)]">
        <div className="absolute inset-0 bg-black/30"></div>
      </div>

      {}
      <div className="relative z-10 flex min-h-screen items-center justify-center px-4 sm:px-6 lg:px-8">
        <div className="container">
          <div className="grid grid-cols-1 gap-8 lg:grid-cols-12 lg:gap-12">
            {}
            

            {}
            <div ref={contentRef} className={`lg:col-span-5 transition-all duration-800 ${contentVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
              <div className="bg-secondary rounded-lg p-8 sm:p-10 lg:p-12 shadow-none">
                <h1 className="font-serif text-center font-semibold leading-tight text-[rgb(245,241,229)]">
                  Raíces que Nutren el Presente
                </h1>

                <div className="mt-8 space-y-6 font-sans leading-relaxed text-foreground">
                  <p>
                    Desde los olivares bañados por el sol español hasta el
                    corazón de La Haya, nuestra historia es un testimonio de
                    amor, dedicación y respeto por la tierra.
                  </p>

                  <p>
                    Paco y Herminia forjaron más que un aceite: construyeron un
                    legado. Cada gota lleva consigo generaciones de sabiduría,
                    el calor del Mediterráneo y el compromiso inquebrantable
                    con la calidad que solo una familia puede ofrecer.
                  </p>

                  <p>
                    Hoy, ese legado cruza fronteras, uniendo dos culturas y
                    manteniendo viva la tradición en cada botella. Esta es
                    nuestra promesa: aceite auténtico, elaborado con el alma.
                  </p>
                </div>

                <div className="mt-10">
                  <Button asChild className="btn w-full sm:w-auto shadow-none">
                    <Link to="#contact">Únete a Nuestro Legado</Link>
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}